/**
 * @format
 */

import 'react-native-gesture-handler';
import {AppRegistry} from 'react-native';
import App from './App';
// import {name as appName} from './app.json';
import './icons';
import './fonts.css';

AppRegistry.registerComponent('housecall', () => App);
AppRegistry.runApplication('housecall', {
  rootTag: document.getElementById('root'),
});
